import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "container model-list"
};
const _hoisted_2 = {
  class: "handle-box"
};
const _hoisted_3 = ["data-id"];
const _hoisted_4 = {
  class: "flex items-center"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  class: "flex items-center"
};
const _hoisted_7 = {
  class: "flex items-center"
};
const _hoisted_8 = {
  class: "flex items-center"
};
const _hoisted_9 = {
  class: "dialog-footer"
};
import { onMounted, onUnmounted, reactive, ref } from "vue";
import { httpGet, httpPost } from "@/utils/http";
import { ElMessage } from "element-plus";
import { dateFormat, removeArrayItem, substr } from "@/utils/libs";
import { DocumentCopy, InfoFilled, Plus, Search } from "@element-plus/icons-vue";
import { Sortable } from "sortablejs";
import ClipboardJS from "clipboard";
import Default from "md-editor-v3";

// 变量定义

export default {
  __name: 'ChatModel',
  setup(__props) {
    const items = ref([]);
    const query = ref({
      name: ""
    });
    const item = ref({});
    const showDialog = ref(false);
    const title = ref("");
    const rules = reactive({
      type: [{
        required: true,
        message: "请选择模型类型",
        trigger: "change"
      }],
      name: [{
        required: true,
        message: "请输入模型名称",
        trigger: "change"
      }],
      value: [{
        required: true,
        message: "请输入模型值",
        trigger: "change"
      }],
      power: [{
        required: true,
        message: "请输入消耗算力",
        trigger: "change"
      }]
    });
    const loading = ref(true);
    const formRef = ref(null);
    const type = ref([{
      label: "聊天",
      value: "chat"
    }, {
      label: "绘图",
      value: "img"
    }]);

    // 获取 API KEY
    const apiKeys = ref([]);
    httpGet("/admin/apikey/list?type=chat").then(res => {
      apiKeys.value = res.data;
    }).catch(e => {
      ElMessage.error("获取 API KEY 失败：" + e.message);
    });

    // 获取数据
    const fetchData = () => {
      httpGet("/admin/model/list", query.value).then(res => {
        if (res.data) {
          // 初始化数据
          const arr = res.data;
          for (let i = 0; i < arr.length; i++) {
            arr[i].last_used_at = dateFormat(arr[i].last_used_at);
          }
          items.value = arr;
        }
        loading.value = false;
      }).catch(() => {
        ElMessage.error("获取数据失败");
      });
    };
    const clipboard = ref(null);
    onMounted(() => {
      fetchData();
      const drawBodyWrapper = document.querySelector(".el-table__body tbody");

      // 初始化拖动排序插件
      Sortable.create(drawBodyWrapper, {
        sort: true,
        animation: 500,
        onEnd({
          newIndex,
          oldIndex,
          from
        }) {
          if (oldIndex === newIndex) {
            return;
          }
          const sortedData = Array.from(from.children).map(row => row.querySelector(".sort").getAttribute("data-id"));
          const ids = [];
          const sorts = [];
          sortedData.forEach((id, index) => {
            ids.push(parseInt(id));
            sorts.push(index + 1);
            items.value[index].sort_num = index + 1;
          });
          httpPost("/admin/model/sort", {
            ids: ids,
            sorts: sorts
          }).then(() => {}).catch(e => {
            ElMessage.error("排序失败：" + e.message);
          });
        }
      });
      clipboard.value = new ClipboardJS(".copy-model");
      clipboard.value.on("success", () => {
        ElMessage.success("复制成功！");
      });
      clipboard.value.on("error", () => {
        ElMessage.error("复制失败！");
      });
    });
    onUnmounted(() => {
      clipboard.value.destroy();
    });
    const add = function () {
      title.value = "新增模型";
      showDialog.value = true;
      item.value = {
        enabled: true,
        power: 1,
        open: true,
        max_tokens: 1024,
        max_context: 8192,
        temperature: 0.9
      };
    };
    const edit = function (row) {
      title.value = "修改模型";
      showDialog.value = true;
      item.value = row;
    };
    const save = function () {
      formRef.value.validate(valid => {
        item.value.temperature = parseFloat(item.value.temperature);
        if (!item.value.sort_num) {
          item.value.sort_num = items.value.length;
        }
        if (valid) {
          showDialog.value = false;
          item.value.key_id = parseInt(item.value.key_id);
          httpPost("/admin/model/save", item.value).then(() => {
            ElMessage.success("操作成功！");
            fetchData();
          }).catch(e => {
            ElMessage.error("操作失败，" + e.message);
          });
        } else {
          return false;
        }
      });
    };
    const modelSet = (filed, row) => {
      httpPost("/admin/model/set", {
        id: row.id,
        filed: filed,
        value: row[filed]
      }).then(() => {
        ElMessage.success("操作成功！");
      }).catch(e => {
        ElMessage.error("操作失败：" + e.message);
      });
    };
    const remove = function (row) {
      httpGet("/admin/model/remove?id=" + row.id).then(() => {
        ElMessage.success("删除成功！");
        items.value = removeArrayItem(items.value, row, (v1, v2) => {
          return v1.id === v2.id;
        });
      }).catch(e => {
        ElMessage.error("删除失败：" + e.message);
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_popconfirm = _resolveComponent("el-popconfirm");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
        modelValue: query.value.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => query.value.name = $event),
        placeholder: "模型名称",
        class: "handle-input"
      }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
        icon: _unref(Search),
        onClick: fetchData
      }, {
        default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("搜索")])),
        _: 1
      }, 8, ["icon"]), _createVNode(_component_el_button, {
        type: "primary",
        icon: _unref(Plus),
        onClick: add
      }, {
        default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("新增")])),
        _: 1
      }, 8, ["icon"])]), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: items.value,
          "row-key": row => row.id,
          "table-layout": "auto"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection",
            width: "38"
          }), _createVNode(_component_el_table_column, {
            prop: "name",
            label: "模型名称"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", {
              class: "sort",
              "data-id": scope.row.id
            }, [_cache[15] || (_cache[15] = _createElementVNode("i", {
              class: "iconfont icon-drag"
            }, null, -1)), _createTextVNode(" " + _toDisplayString(scope.row.name), 1)], 8, _hoisted_3)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "type",
            label: "模型类型"
          }, {
            default: _withCtx(scope => [scope.row.type === 'img' ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              type: "primary"
            }, {
              default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("绘图")])),
              _: 1
            })) : (_openBlock(), _createBlock(_component_el_tag, {
              key: 1,
              type: "success"
            }, {
              default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode("聊天")])),
              _: 1
            }))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "value",
            label: "模型值"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row.value), 1), _createVNode(_component_el_icon, {
              class: "copy-model",
              "data-clipboard-text": scope.row.value
            }, {
              default: _withCtx(() => [_createVNode(_unref(DocumentCopy))]),
              _: 2
            }, 1032, ["data-clipboard-text"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "power",
            label: "费率"
          }), _createVNode(_component_el_table_column, {
            prop: "max_tokens",
            label: "最大响应长度"
          }), _createVNode(_component_el_table_column, {
            prop: "max_context",
            label: "最大上下文长度"
          }), _createVNode(_component_el_table_column, {
            prop: "temperature",
            label: "创意度"
          }), _createVNode(_component_el_table_column, {
            prop: "enabled",
            label: "启用状态"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_switch, {
              modelValue: scope.row['enabled'],
              "onUpdate:modelValue": $event => scope.row['enabled'] = $event,
              onChange: $event => modelSet('enabled', scope.row)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "enabled",
            label: "开放状态"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_switch, {
              modelValue: scope.row['open'],
              "onUpdate:modelValue": $event => scope.row['open'] = $event,
              onChange: $event => modelSet('open', scope.row)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "key_name",
            label: "绑定API-KEY"
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "180"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              onClick: $event => edit(scope.row)
            }, {
              default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode("编辑")])),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_popconfirm, {
              title: "确定要删除当前记录吗?",
              onConfirm: $event => remove(scope.row),
              width: 200
            }, {
              reference: _withCtx(() => [_createVNode(_component_el_button, {
                size: "small",
                type: "danger"
              }, {
                default: _withCtx(() => _cache[19] || (_cache[19] = [_createTextVNode("删除")])),
                _: 1
              })]),
              _: 2
            }, 1032, ["onConfirm"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data", "row-key"])]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => showDialog.value = $event),
        title: title.value,
        "close-on-click-modal": false,
        style: {
          "width": "90%",
          "max-width": "600px"
        }
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_9, [_createVNode(_component_el_button, {
          onClick: _cache[11] || (_cache[11] = $event => showDialog.value = false)
        }, {
          default: _withCtx(() => _cache[24] || (_cache[24] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => _cache[25] || (_cache[25] = [_createTextVNode("提交")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: item.value,
          "label-width": "120px",
          ref_key: "formRef",
          ref: formRef,
          rules: rules
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "模型类型：",
            prop: "type"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: item.value.type,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => item.value.type = $event),
              placeholder: "请选择模型类型"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type.value, v => {
                return _openBlock(), _createBlock(_component_el_option, {
                  value: v.value,
                  label: v.label,
                  key: v.value
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(v.label), 1)]),
                  _: 2
                }, 1032, ["value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "模型名称：",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.name,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => item.value.name = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "模型值：",
            prop: "value"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => item.value.value = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "消耗算力：",
            prop: "power"
          }, {
            label: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_cache[20] || (_cache[20] = _createElementVNode("span", {
              class: "mr-1"
            }, "消耗算力", -1)), _createVNode(_component_el_tooltip, {
              effect: "dark",
              content: "每日签到赠送算力",
              "raw-content": "",
              placement: "right"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                _: 1
              })]),
              _: 1
            })])]),
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.power,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => item.value.power = $event),
              modelModifiers: {
                number: true
              },
              autocomplete: "off",
              placeholder: "消耗算力"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), item.value.type === 'chat' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_form_item, {
            label: "最长响应：",
            prop: "max_tokens"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.max_tokens,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => item.value.max_tokens = $event),
              modelModifiers: {
                number: true
              },
              autocomplete: "off",
              placeholder: "模型最大响应长度"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            label: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_cache[21] || (_cache[21] = _createElementVNode("span", {
              class: "mr-1"
            }, "最大上下文", -1)), _createVNode(_component_el_tooltip, {
              effect: "dark",
              content: "去各大模型的官方 API 文档查询模型支持的最大上下文长度",
              "raw-content": "",
              placement: "right"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                _: 1
              })]),
              _: 1
            })])]),
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.max_context,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => item.value.max_context = $event),
              modelModifiers: {
                number: true
              },
              autocomplete: "off",
              placeholder: "模型最大上下文长度"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "创意度：",
            prop: "temperature"
          }, {
            label: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_cache[22] || (_cache[22] = _createElementVNode("span", {
              class: "mr-1"
            }, "创意度", -1)), _createVNode(_component_el_tooltip, {
              effect: "dark",
              content: "OpenAI 0-2，其他模型 0-1",
              "raw-content": "",
              placement: "right"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                _: 1
              })]),
              _: 1
            })])]),
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.temperature,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => item.value.temperature = $event),
              autocomplete: "off",
              placeholder: "模型创意度"
            }, null, 8, ["modelValue"])]),
            _: 1
          })])) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: "绑定API-KEY：",
            prop: "apikey"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: item.value.key_id,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => item.value.key_id = $event),
              placeholder: "请选择 API KEY",
              filterable: "",
              clearable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(apiKeys.value, v => {
                return _openBlock(), _createBlock(_component_el_option, {
                  value: v.id,
                  label: v.name,
                  key: v.id
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(v.name) + " ", 1), _createVNode(_component_el_text, {
                    type: "info",
                    size: "small"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(substr)(v.api_url, 50)), 1)]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1032, ["value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "启用状态：",
            prop: "enable"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: item.value.enabled,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => item.value.enabled = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            label: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_cache[23] || (_cache[23] = _createElementVNode("span", {
              class: "mr-1"
            }, "开放状态", -1)), _createVNode(_component_el_tooltip, {
              effect: "dark",
              content: "开放后，该模型将对所有用户可见。<br/> 如果模型没有启用，则当前设置无效。",
              "raw-content": "",
              placement: "right"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                _: 1
              })]),
              _: 1
            })])]),
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: item.value.open,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => item.value.open = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title"])])), [[_directive_loading, loading.value]]);
    };
  }
};